var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'react';
import { getIndexForMapeo } from '../../TempSale/TempSalePacket';
import { Button, DatePicker, Text, View } from '../../../elements';
import React from 'react';
import theme from '../../../Theme';
import { T } from '../../../helpers/i18n';
import { checkDisabledDay, twoDigits } from '../../../helpers/Utils';
import { observer } from 'mobx-react';
import { Modal } from '../../../components';
let StretchPacketConfig = class StretchPacketConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datePickerVisible: false
        };
        this.handleHour = (hour) => {
            this.props.onChangeHours(this.props.stretch, hour);
        };
        this.handleDate = (date) => {
            this.props.onChangeDate(this.props.stretch, (date));
        };
        // selecciono la hora si sólo hay una
        if (this.props.hoursSelected && this.props.hoursSelected.length === 1) {
            this.props.onChangeHours(this.props.stretch, this.props.hoursSelected[0]);
        }
    }
    render() {
        const { stretch, tempSalePacket, hoursSelected, idaVueltaSelected, datePickerVisible, datebooking, onChangeDate } = this.props;
        const index = getIndexForMapeo(stretch);
        const hourSelected = tempSalePacket.hoursSelected[index];
        const dateSelected = tempSalePacket.datesSelected[index] || new Date();
        const disabledDate = checkDisabledDay(stretch.horasIda, stretch.disabledDays, dateSelected);
        return (React.createElement(View, { style: {
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'black',
                borderRadius: 5,
                margin: 5,
                padding: 5
            } },
            React.createElement(Text, { big: true }, stretch.name),
            React.createElement(View, { style: { flex: 2 } },
                React.createElement(View, { row: true, style: { justifyContent: 'flex-start', alignItems: 'center' }, onClick: () => this.setState({ datePickerVisible: true }) },
                    React.createElement(Text, null, `${twoDigits(dateSelected.getDate())}/${twoDigits(dateSelected.getMonth() + 1)}/${twoDigits(dateSelected.getFullYear())}`),
                    stretch.vuelta &&
                        React.createElement(ShowVuelta, { idaVueltaSelected: idaVueltaSelected })),
                disabledDate &&
                    React.createElement(View, null,
                        React.createElement(Text, { center: true, style: { backgroundColor: theme.color.primary, color: 'white', height: theme.size.bar, width: '100%' } }, `${T('dateUnavailable')} ${twoDigits(dateSelected.getDate())}/${twoDigits(dateSelected.getMonth() + 1)}/${twoDigits(dateSelected.getFullYear())}`)),
                hoursSelected &&
                    React.createElement(View, null,
                        React.createElement(Text, null, 'Hora de uso'),
                        React.createElement(View, { row: true, style: { padding: 1 } }, hoursSelected.map(horaIda => (React.createElement(RenderHours, { key: horaIda.id, horaIda: horaIda, primary: hourSelected && hourSelected.id === horaIda.id, handleHour: this.handleHour, disabled: disabledDate })))))),
            this.state.datePickerVisible && (React.createElement(Modal, { title: T('dateBook') },
                React.createElement(DatePicker, { name: 'dateBook', 
                    /*date={date}*/
                    date: datebooking, onChange: (date, value) => {
                        console.log('value: ', value);
                        onChangeDate(stretch, value);
                        this.setState({ datePickerVisible: false });
                    }, stretch: stretch, calendarAvailable: true, disabledDays: stretch.disabledDays })))));
    }
};
StretchPacketConfig = __decorate([
    observer
], StretchPacketConfig);
export default StretchPacketConfig;
const RenderHours = ({ horaIda, primary, handleHour, disabled }) => {
    return (React.createElement(Button, { onClick: () => { handleHour(horaIda); }, key: horaIda.id, style: { height: 35 }, disabled: disabled },
        React.createElement(Text, { style: {
                backgroundColor: primary ? 'green' : undefined,
                color: primary ? 'white' : 'black',
                height: 30,
                borderWidth: 1,
                borderColor: 'black',
                borderStyle: 'solid',
                borderRadius: 5,
                padding: 5,
                marginLeft: 1,
                marginRight: 1,
            } }, `${horaIda.hours > 9 ? horaIda.hours : '0' + horaIda.hours}:${horaIda.minutes > 9 ? horaIda.minutes : '0' + horaIda.minutes}`)));
};
const ShowVuelta = ({ idaVueltaSelected }) => {
    if (idaVueltaSelected) {
        return (React.createElement(WrapperShowVuelta, null, T('idaVuelta')));
    }
    return React.createElement(WrapperShowVuelta, null, T('ida'));
};
const WrapperShowVuelta = props => (React.createElement(Text, Object.assign({ center: true, style: {
        backgroundColor: theme.color.primary,
        color: 'white',
        paddingLeft: 5,
        paddingRight: 5,
        minHeight: 30,
        minWidth: 50
    } }, props), props.children));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/container/StretchPacketConfig.tsx
// module id = 565
// module chunks = 0